// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Bm3IF","content":"styles_content__1q7f1"};